import { AppThunkAction } from "..";
import { SecurityAssesmentTypes, RECEIVE_SECURITY_ASSESSMENT_DATA, REQUEST_SECURITY_ASSESSMENT_DATA } from "./types";
import * as services from "../service";

export const actionCreators = {
    requestAssesmentSummary:
        (forceFullyRefresh: boolean): AppThunkAction<SecurityAssesmentTypes> =>
            (dispatch, getState) => {
                const appState = getState();
                const recallApi = JSON.parse(sessionStorage.getItem('recallApi') || 'false');
                if (
                    appState &&
                    appState.securityAssesmentState &&
                    ((!appState.securityAssesmentState.assessmentData && !appState.securityAssesmentState.isLoading) || forceFullyRefresh === true || recallApi)
                ) {
                    // if (appState != null && appState.securityAssesmentState != null && ((appState.securityAssesmentState.assessmentData == null && appState.securityAssesmentState.isLoading === false) || forceFullyRefresh === true)) {
                    services
                        .getSecurityAssessmentReview()
                        .then((data) => {
                            services.getSecurityAssessmentQuestionaires().then((questionData) => {
                                if (!questionData.HasError && questionData.EZSQuestions && questionData.EZSQuestions.length > 0) {
                                    data.questions = questionData.EZSQuestions;
                                    dispatch({ type: RECEIVE_SECURITY_ASSESSMENT_DATA, assessmentData: data });
                                    sessionStorage.setItem('recallApi', JSON.stringify(false));
                                }
                            });
                        })
                        .catch(function (error) {
                            dispatch({ type: RECEIVE_SECURITY_ASSESSMENT_DATA, assessmentData: [] as any });
                        });
                    dispatch({ type: REQUEST_SECURITY_ASSESSMENT_DATA });
                }
            },
};
